import { useRouter } from 'next/router';

const useRedirectToFirstPage = (url: string, isStaticPages?: boolean) => {
  const router = useRouter();

  let pageNo: any;

  //Проверка на статические страницы
  if (!!isStaticPages) {
    const staticPagePathSplit = router.pathname.split('/');
    pageNo = staticPagePathSplit[staticPagePathSplit.length - 1];
  } else {
    pageNo = router?.query.pageNumber;
  }

  if (pageNo === '1') {
    typeof window !== 'undefined' && router.push(url);
  }
};

export default useRedirectToFirstPage;
